

































































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { filterDate } from '~/assets/filters/date'
import { IStyle } from '~/assets/interfaces/classes'
import { ISliderItem } from '~/assets/interfaces/slider'
import { ICatalogCategoryItem } from '~/assets/interfaces/catalog'
import { InterfaceProductsBlock } from '~/assets/interfaces/products'
import { IArticle } from '~/assets/interfaces/articles'
import ComponentArticleItem from '~/components/articles/article-item.vue'
import ComponentNavigationBreadcrumbs from '~/components/navigation/breadcrumbs.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import ComponentImage from '~/components/images/image.vue'
import ComponentIntersect from '~/components/intersect/intersect.vue'
import ComponentCatalogCategoryItem from '~/components/catalog/category/category-item.vue'
import ComponentSliderStandard from '~/components/slider/standard.vue'
import ComponentHeaderWithLink from '~/components/header/header-with-link.vue'
import ComponentProductItem1 from '~/components/products/product-item-1.vue'

interface ISlider {
  desktop: ISliderItem[]
  mobile: ISliderItem[]
}

interface ICategories {
  items: ICatalogCategoryItem[]
}

interface IArticles {
  items: IArticle[]
}

@Component({
  components: {
    ComponentNavigationBreadcrumbs,
    ComponentPageContent,
    ComponentTypographyH1,
    ComponentImage,
    ComponentIntersect,
    ComponentCatalogCategoryItem,
    ComponentSliderStandard,
    ComponentHeaderWithLink,
    ComponentProductItem1,
    ComponentArticleItem,
  },
  filters: {
    filterDate,
  },
})
export default class ComponentPageBrandsIdType1 extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isLoading!: boolean
  @Prop({ type: String }) readonly logo!: string
  @Prop({ type: Object }) readonly slider!: ISlider
  @Prop({ type: Object }) readonly categories!: ICategories
  @Prop({ type: Object }) readonly articles!: IArticles
  @Prop({ type: Array }) readonly products!: InterfaceProductsBlock[]
  @Prop({ type: String, default: '' }) readonly description: string

  private styleSpacer!: IStyle
  private $style!: IStyle

  private get classMbGutter() {
    return {
      [this.styleSpacer.mbGutter2]: !this.$device.isMobileOrTablet,
      [this.styleSpacer.mbGutter]: this.$device.isMobileOrTablet,
    }
  }

  private get classProducts() {
    return {
      [this.$style.products]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  private get classNews() {
    return {
      [this.$style.news]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }
}
